export default __webpack_public_path__ + "static/media/sc-top.2223dab8.svg";